import { render, staticRenderFns } from "./GoodsAnalysis.vue?vue&type=template&id=fea580d2&scoped=true&"
import script from "./GoodsAnalysis.vue?vue&type=script&lang=js&"
export * from "./GoodsAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAnalysis.vue?vue&type=style&index=0&id=fea580d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea580d2",
  null
  
)

export default component.exports